import React from 'react';
import { Fab, Icon, Paper } from '@mui/material';
import { Stack as MuiStack } from '@mui/material';
import { DataTypeProvider, FilteringState } from '@devexpress/dx-react-grid';
import { Grid, TableColumnResizing, TableFilterRow, TableHeaderRow, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { applyGridTableFilter, vehicleToStringRaw as vehicleToStringRaw } from './_Utils/AppDocuCommon';
import AddVehicleDialog from './Vehicle_Components/AddVehicleDialog';
import ActionsTypeProvider from './Vehicle_TypeProviders/ActionsTypeProvider';
import RowNumTypeProvider from './_Utils/RowNumTypeProvider';
import { BrandTypeProvider, ModelTypeProvider } from './Vehicle_TypeProviders/BrandModelTypeProvider';
import { tableColumns, tableColumnWidths, tableColumnExtensions, tableFilteringStateColumnExtensions } from './Vehicle_Components/_GridTableProps';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import ActionFiltersDialog from './Vehicle_Components/ActionFiltersDialog';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import StatusTypeProvider from './Vehicle_TypeProviders/StatusTypeProvider';
import { DocBrandsTypeProvider, PkgCalBrandsTypeProvider } from './Vehicle_TypeProviders/CountersTypeProvider';

class AppDocuVehiclePage extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {      
      tableColumnWidths: tableColumnWidths,      
      tableFilters: [],
      actionFilters: { document: 'all', package: 'all', calibration: 'all', image: 'all' },
      localVehicles: this.getFilteredVehicles(props.vehicles, [], { document: 'all', package: 'all', calibration: 'all', image: 'all' }),
      addVehicleDialogIsOpen: false,
      actionFilterDialogIsOpen: false,
    };
  }
  getFilteredVehicles(vehicles, tableFilters, actionFilters) {
    let filteredVehicles = vehicles || [];
    filteredVehicles = filteredVehicles.filter(row => {
      return tableFilters.every(f => {
        const col = tableColumns.find(c => c.name === f.columnName);
        const isNumber = col && col.isNumber;
        return applyGridTableFilter(row[f.columnName], f.value, f.operation || "contains", isNumber);
      });
    });
    filteredVehicles = filteredVehicles.filter(row => {
      let doc = true, pkg = true, cal = true, img = true;
      if (actionFilters.document === 'with') doc = row.document_count > 0;
      if (actionFilters.document === 'without') doc = !row.document_count;
      if (actionFilters.package === 'with') pkg = row.package_count > 0;
      if (actionFilters.package === 'without') pkg = !row.package_count;
      if (actionFilters.calibration === 'with') cal = row.calibration_count > 0;
      if (actionFilters.calibration === 'without') cal = !row.calibration_count;
      if (actionFilters.image === 'with') img = row.has_image;
      if (actionFilters.image === 'without') img = !row.has_image;
      return doc && pkg && cal && img;
    });
    // Calcola row_num dopo il filtro e aggiungi onEdit per ogni riga
    filteredVehicles = filteredVehicles.map((m, idx) => ({
      ...m,
      row_num: idx + 1,      
    }));
    return filteredVehicles;
  }
  applyTableFilters = (value) => {
    this.setState({
      tableFilters: value,
      localVehicles: this.getFilteredVehicles(this.props.vehicles, value, this.state.actionFilters),
    });
  }
  applyActionFilters = (value) => {
    this.setState({ 
      actionFilters: value, 
      localVehicles: this.getFilteredVehicles(this.props.vehicles, this.state.tableFilters, value),
      actionFilterDialogIsOpen: false,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.vehicles !== this.props.vehicles) {
      this.setState({
        localVehicles: this.getFilteredVehicles(this.props.vehicles, this.state.tableFilters, this.state.actionFilters),
      });
    }
  }  
  handleReportClick = async () => {
    let report = '';
    let vehicles = this.state.localVehicles 
    if (vehicles.length > 0) {
      for (let i = 0; i < vehicles.length; i++) {
        const m = vehicles[i];
        report += `${vehicleToStringRaw(m.id, m)}\n`;
      }
    } else {
      report += '(No cars)\n';
    }
    report += '\n';
    window.open().document.write(`<pre>${report}</pre>`);
  }
  isActionFiltersActive() {
    const { document, package: pkg, calibration, image } = this.state.actionFilters;
    return document !== 'all' || pkg !== 'all' || calibration !== 'all' || image !== 'all';
  }
  render() {
    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>
        <MuiStack direction="row" spacing={2} sx={{ position: 'fixed', bottom: (theme) => theme.spacing(3), right: (theme) => theme.spacing(5), zIndex: 1200 }}>
          <Fab
            onClick={() => this.setState({ actionFilterDialogIsOpen: true })}
            variant="extended"
            color={this.isActionFiltersActive() ? 'warning' : 'default'}
            aria-label="filter"
          >
            <FilterAltIcon sx={{ mr: 1 }} />
            FILTRO AZIONI
          </Fab>
          <Fab
            onClick={() => this.setState({ addVehicleDialogIsOpen: true })}
            variant="extended"
            color="primary"
            aria-label="add"            
          >
            <AddIcon sx={{ mr: 1 }} />
            ADD NEW
          </Fab>
          <Fab
            onClick={this.handleReportClick}
            variant="extended"
            color="secondary"
            aria-label="report"            
          >
            <DescriptionIcon sx={{ mr: 1 }} />
            REPORT
          </Fab>          
        </MuiStack>

        <Grid
          rows={this.state.localVehicles}
          columns={tableColumns}
          getRowId={row => row.id}          
        >
          <ActionsTypeProvider 
            for={[ "actions" ]} 
            onItemsChange={this.props.onItemsChange} />
          <DocBrandsTypeProvider for={[ "doc_brands" ]} />
          <PkgCalBrandsTypeProvider for={[ "pkg_cal_brands" ]} />
          <RowNumTypeProvider for={[ "row_num" ]} /> 
          <BrandTypeProvider DataTypeProvider={DataTypeProvider} for={["brand"]} />
          <ModelTypeProvider DataTypeProvider={DataTypeProvider} for={["model"]} />
          <StatusTypeProvider for={[ "status" ]} />
          <DataTypeProvider  
            for={[ "id", "cylinders", "displacement", "power" ]}
            availableFilterOperations={[ 'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual' ]} />
          <VirtualTable 
            height={height}
            columnExtensions={tableColumnExtensions}
          />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.applyTableFilters.bind(this)}
            columnExtensions={tableFilteringStateColumnExtensions} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow contentComponent={props => (<TableHeaderRow.Content {...props} style={{ minHeight: 0, height: 0, paddingTop: 0, paddingBottom: 0, fontSize: 12 }} />)} />
          <TableFilterRow showFilterSelector />
        </Grid>

        <AddVehicleDialog
          isOpen={this.state.addVehicleDialogIsOpen}
          onClose={() => this.setState({ addVehicleDialogIsOpen: false })}
          onItemsChange={this.props.onItemsChange}
        />
        
        <ActionFiltersDialog
          open={this.state.actionFilterDialogIsOpen}
          onClose={() => this.setState({ actionFilterDialogIsOpen: false })}
          onApply={this.applyActionFilters}
          initial={this.state.actionFilters}
        />
      </Paper>
    );
  }
}

export default AppDocuVehiclePage;
